import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


import { ref } from 'vue'
import { adminAreaSave, adminAreaUpdate, adminAreaListByParentId } from '@/api/gucangSales/administrativeRegion'
import type { FormInstance } from 'ant-design-vue'
import { message } from '@dc-platform/dc-components'
import { adminAreaSaveParams } from '@/typings/api/gucangSale'

const __default__ = { name: 'editModalProvince' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<adminAreaSaveParams>({})
const emit = __emit
const toggle = (row?: adminAreaSaveParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
    console.log('editForm.value: ', editForm.value)
  } else {
    editForm.value = {}
  }
}
const conuntryArr = ref<adminAreaSaveParams[]>([])
const getCountry = async () => {
  try {
    const res:any = await adminAreaListByParentId({ parentId: '-1', level: 1 })
    conuntryArr.value = res.data
    return res.data
  } catch (error) {
    console.log('getCountry error: ', error)
  }
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const p = editForm.value
    const index = conuntryArr.value.findIndex((item:adminAreaSaveParams) => item.countryCharCode === editForm.value.countryCharCode)

    try {
      if (editForm.value.id) {
        await adminAreaUpdate({
          ...p,
          id: editForm.value.id,
          level: 2,
          name: editForm.value.provinceName,
          fullName: `${conuntryArr.value[index].countryCnName}/${editForm.value.provinceName}`
        })
      } else {
        await adminAreaSave({
          ...p,
          level: 2,
          name: editForm.value.provinceName,
          fullName: `${conuntryArr.value[index].countryCnName}/${editForm.value.provinceName}`,
          countryCnName: conuntryArr.value[index].countryCnName,
          countryEnName: conuntryArr.value[index].countryEnName,
          parentId: conuntryArr.value[index].id
        })
      }
      toggle()
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      message.success(editForm.value?.id ? '编辑成功' : '新增成功')
    } catch (error) {
      loading.value = false
    }
  })
}
__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_CosApiSelect = _resolveComponent("CosApiSelect")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!
  const _directive_trim = _resolveDirective("trim")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    title: editForm.value.id ? '编辑' : '新增',
    width: "600px",
    onOk: handleSubmit,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: editForm.value,
            ref_key: "formRef",
            ref: formRef,
            autocomplete: "off"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "countryCharCode",
                label: "国家中文名",
                rules: [{ required: true, message: '请选择' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CosApiSelect, {
                    api: getCountry,
                    allowClear: false,
                    "show-search": "",
                    optionFilterProp: "label",
                    value: editForm.value.countryCharCode,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((editForm.value.countryCharCode) = $event)),
                    fieldNames: { label: 'countryCnName', value: 'countryCharCode' }
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "provinceName",
                label: "省 / 州:",
                rules: [{ required: true, message: '请输入' }]
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_a_input, {
                    value: editForm.value.provinceName,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((editForm.value.provinceName) = $event)),
                    placeholder: "请输入"
                  }, null, 8, ["value"]), [
                    [_directive_trim]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "title", "confirmLoading"]))
}
}

})